(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-with-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('grafilabel-iwt-video')) {
  customElements.define('grafilabel-iwt-video', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.abort) return;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const showControls = this.dataset.controls === 'true';
      video.muted = true;
      video.controls = showControls;
      button.hidden = showControls;

      const updateButton = () => {
        const paused = video.paused || video.ended;
        button.textContent = paused ? 'Afspelen' : 'Pauzeren';
        button.setAttribute('aria-label', paused ? 'Video afspelen' : 'Video pauzeren');
      };
      const play = () => {
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(updateButton);
      };
      button.addEventListener('click', () => {
        if (video.paused || video.ended) play();
        else video.pause();
      }, options);
      ['play', 'pause', 'ended', 'error'].forEach(event => {
        video.addEventListener(event, updateButton, options);
      });
      motion.addEventListener('change', event => {
        if (event.matches) video.pause();
      }, options);
      updateButton();
      if (this.dataset.autoplay === 'true' && !motion.matches) play();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.abort) this.abort.abort();
      this.abort = null;
      const video = this.querySelector('video');
      if (video) video.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gl-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gl-product-slider')) {
    customElements.define(
      'gl-product-slider',
      class GlProductSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gl-track]');
          if (!this.track) return;

          this.prevButton = this.querySelector('[data-gl-prev]');
          this.nextButton = this.querySelector('[data-gl-next]');
          this.handlePrev = () => this.go(-1);
          this.handleNext = () => this.go(1);
          this.handleScroll = () => this.update();

          if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
          if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);
          this.track.addEventListener('scroll', this.handleScroll, { passive: true });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.update());
            this.resizeObserver.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
        }

        step() {
          const slide = this.track.querySelector('.gl-ps__slide');
          if (!slide) return this.track.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const size = slide.getBoundingClientRect().width + gap;
          const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / size));
          return perView * size;
        }

        go(direction) {
          this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          if (this.prevButton) this.prevButton.disabled = x <= 2;
          if (this.nextButton) this.nextButton.disabled = x >= max - 2;
          this.toggleAttribute('data-static', max <= 2);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
